export default "__VITE_ASSET__D1xka_yA__"